import DesktopWindowsRoundedIcon from '@material-ui/icons/DesktopWindowsRounded';
import CategoryRoundedIcon from '@material-ui/icons/CategoryRounded';
import Keyboard from '@material-ui/icons/Keyboard';
import Reports from '@material-ui/icons/BarChartSharp';
import EmojiPeopleRoundedIcon from '@material-ui/icons/EmojiPeopleRounded';
import WbIncandescentRoundedIcon from '@material-ui/icons/WbIncandescentRounded';
import TabRoundedIcon from '@material-ui/icons/TabRounded';
import Calulator from '@mui/icons-material/Calculate';

// ✅ Use `titleKey` instead of Marathi strings
export const SidebarData0 = [
  {
    icon: DesktopWindowsRoundedIcon,
    titleKey: "sidebar.menu.idairygrow",
    pathname: "/idairygrow"
  },
];

export const SidebarData1 = [
  {
    icon: DesktopWindowsRoundedIcon,
    titleKey: "sidebar.menu.master",
    pathname: "/Dashboard"
  },
  {
    icon: Keyboard,
    titleKey: "sidebar.menu.daily",
    pathname: "/Transections"
  },
  {
    icon: CategoryRoundedIcon,
    titleKey: "sidebar.menu.other_voucher",
    pathname: "/ivouchers"
  },
  {
    icon: Calulator,
    titleKey: "sidebar.menu.audit",
    pathname: "/audit"
  },
  {
    icon: Reports,
    titleKey: "sidebar.menu.reports",
    pathname: "/reports"
  }
];

export const SidebarData2 = [
  {
    icon: EmojiPeopleRoundedIcon,
    titleKey: "sidebar.menu.extra",
    pathname: "/extra"
  },
  {
    icon: WbIncandescentRoundedIcon,
    titleKey: "sidebar.menu.help",
    pathname: "/help"
  }
];

export const SidebarData3 = [
  {
    icon: TabRoundedIcon,
    titleKey: "sidebar.menu.registration",
    pathname: "/regi"
  }
];
